export const contact = {
  phoneDisplay: '+44 (0)7860 581780',
  phoneHref: 'tel:+447860581780',
  email: 'jim.godfrey@godfrey.uk.com',
  location: 'North Lincolnshire, UK',
  linkedinUrl: 'https://www.linkedin.com/in/james-jim-godfrey-733565b',
  linkedinDisplay: 'linkedin.com/in/james-jim-godfrey-733565b',
};
